import { useEffect, useState } from "react";
import { HEADER_DATA_UPDATE } from "../../../redux/reducers/header.reducer";
import { Autocomplete, Box, Button, FormControl, FormHelperText, Grid, IconButton, MenuItem, Select, TextField } from "@mui/material";
import { useDispatch } from "react-redux";
import { useLoading } from "../../../components/Loading/useLoading";
import { CrearReporte, GetEntity } from "../../../hooks/reporteQuery";
import { Cancel, Delete, Search } from "@mui/icons-material";
import { SideList } from "./components/sideList";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";


export const NuevaQuery = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {setAppLoading} = useLoading();
  const { enqueueSnackbar } = useSnackbar();
  const { getEntityMutation } = GetEntity();
  const { crearReporteMutation } = CrearReporte();
  const [reportName, setReportName] = useState(null);
  const [reportDesc, setReportDesc] = useState(null);

  //Transferlist
  const [originalList, setOriginalList] = useState([]);
  const [leftList, setLeftList] = useState([]);
  const [rightList, setRightList] = useState([]);
  const [selectedToLeft, setSelectedToLeft] = useState([]);
  const [selectedToRight, setSelectedToRight] = useState([]);
  const [filtro, setFiltro] = useState("");
  const [listaFiltrada, setListaFiltrada] = useState([]);

  //WHERES
  const [conditionsFields, setConditionsFields] = useState([]);

  useEffect(() => {
    dispatch(
        HEADER_DATA_UPDATE({nombreData: 'Nuevo Reporte'})
    )
    get_entity();
  }, []);

  //ENTIDADES

  const get_entity = () => {
    setAppLoading(true)
    getEntityMutation({}, {
      onSuccess: (data) => {
        setLeftList(data?.data);
        setListaFiltrada(data?.data)
        setOriginalList(data?.data)
        setAppLoading(false);
      },
      onError: (error) => {
        console.log(error);
        setAppLoading(false);
      }
    })
  }
  const handleSelect = (side, col, alias) => {

    let data = side === 'left' ? structuredClone(selectedToRight) : structuredClone(selectedToLeft);
    let data_left = null;
    let entity = alias !== undefined && alias !== null ?
      data.findIndex((item) => item.alias === alias) :
      data.findIndex((item) => item.name === col.main_entity)
    
    if(side === 'left' && col.relation_name){
      data_left = [...leftList];
      let entity = data_left.findIndex((item) => item.name === col.main_entity);
      let item_exist = data_left[entity].columns.filter(item => item.relation_name === col.relation_name);
      if(item_exist.length > 1){
        let item_add = data_left.find(item => item.name === col.relation_name);
        let exist_alias = data_left.findIndex((ent) => ent.alias === col.name);
        if(exist_alias === -1){
          data_left.push({
            name: item_add.name,
            columns: item_add.columns,
            relations: item_add.relations,
            alias: col?.name,
            description: item_add.description
          })
        }
        setLeftList([...data_left]);
      }
    }
    if(entity !== -1){
      const index = data[entity]?.columns?.findIndex(
        (item) => item.name === col.name
      );
      if (index !== -1) {
        // Si el objeto existe, lo eliminamos
        data[entity].columns.splice(index, 1)
      } else {
        // Si no existe, lo agregamos
        data[entity].columns.push(col)
      }
    }else{
      let entity = originalList.find(item => item.name === col?.main_entity);
      let new_data = {
        name: col?.main_entity,
        columns: [col],
        relations: entity?.relations,
        alias,
        description: entity?.description
      }
      data.push(new_data)
    }


    side === 'left' ? setSelectedToRight([...data]) : setSelectedToLeft([...data]);

  }
  const handleSelectAllEntity = (side, entidad) => {
    let entities = side === 'left' ? structuredClone(selectedToRight) : structuredClone(selectedToLeft);
    let setEntities = side === 'left' ? setSelectedToRight : setSelectedToLeft;
    let exist = entities.findIndex(ent => ent.name === entidad.name && ent.alias === ent.alias);
    let columnas_data = [];
    if(exist === -1){
      entities.push(entidad);
      columnas_data = [...entidad.columns];
    }else{
      let columnas = [...entities[exist].columns, ...entidad.columns];
      let uniqueColumns = Array.from(
        new Map(columnas.map(obj => [obj.name, obj])).values()
      );
      entities[exist].columns = uniqueColumns;
      columnas_data = [...uniqueColumns];
    }

    if(side === 'left'){
      let data_left = [...leftList];
      columnas_data.map(col => {
        if(col.relation_name){
          let entity = data_left.findIndex((item) => item.name === col.main_entity);
          let item_exist = data_left[entity].columns.filter(item => item.relation_name === col.relation_name);
          if(item_exist.length > 1){
            let item_add = {...data_left.find(item => item.name === col.relation_name)};
            let exist_alias = data_left.findIndex((ent) => ent.alias === col.name);
            if(exist_alias === -1){
              data_left = [...data_left, {
                name: item_add.name,
                columns: item_add.columns,
                relations: item_add.relations,
                alias: col?.name
              }]
            }

            
          }
        }
      })
      setListaFiltrada([...data_left]);
      setLeftList([...data_left]);
      console.log(data_left)
    }
    setEntities(entities);
  }
  const moveItems = (side) => {
    let moveItems = side === 'left' ? structuredClone(selectedToRight) : structuredClone(selectedToLeft);
    let deleteItems = side === 'left' ? structuredClone(leftList) : structuredClone(rightList);
    let actualItems = side === 'left' ? structuredClone(rightList) : structuredClone(leftList);
    let setItems = side === 'left' ? setRightList : setLeftList;
    let setItemsDel = side === 'left' ? setLeftList : setRightList;
    //Agregar al lado a mover
    for(let entity of moveItems){
      let index_ent = entity?.alias !== undefined && entity?.alias !== null ?
      actualItems.findIndex((item) => item.alias === entity.alias) :
      actualItems.findIndex((item) => item.name === entity.name);
      let index_del = entity?.alias !== undefined && entity?.alias !== null ?
      deleteItems.findIndex((item) => item.alias === entity.alias) :
      deleteItems.findIndex((item) => item.name === entity.name);
      if(index_ent !== -1){
        entity.columns.map(col => {
          let index = actualItems[index_ent].columns.findIndex((item) => item.name === col.name);
          if(index === -1){
            actualItems[index_ent].columns.push(col)
          }
        })
      }else{
        actualItems.push(entity)
      }

      if(index_del !== -1){
        entity.columns.map(col => {
          let index = deleteItems[index_del].columns.findIndex((item) => item.name === col.name);
          if(index !== -1){
            deleteItems[index_del].columns.splice(index, 1);
            if(side === 'right'){
              let conditions = [...conditionsFields]
              conditions.map((or, index) => {
                let i_del = or.findIndex(and => and.field === col.name && and.alias === entity.alias);
                if(i_del !== -1){
									conditions[index].splice(i_del, 1);
								}
              })
              setConditionsFields([...conditions])
            }
          }
        })
      }

      if(deleteItems[index_del].columns.length === 0){
        deleteItems.splice(index_del, 1)
      }
    }

    if(side === 'right'){
      let flag = true;
      while (flag) {
        flag = false;
        let verifyItems = [...deleteItems];
        deleteItems.map((entity, index) => {
          if(index !== 0){
            const relationsSet = new Set(entity.relations);
            let items_filter = verifyItems.filter(item => relationsSet.has(item.name));
            if(items_filter.length > 0){
              let exist = items_filter.some(item => 
                item?.columns?.some(col => 
                  col.relation_name === entity.name || col.target_entity_inter === entity.name)
              )
              if(!exist){
                flag = true;
                let index_del = verifyItems.findIndex((item) => item.name === entity.name);
                let cols_to_add = verifyItems[index_del]?.columns;
                let index_add = actualItems.findIndex(item => item.name === entity.name);
                actualItems[index_add].columns.push(...cols_to_add);
                verifyItems.splice(index_del, 1);
              }
            }
          }
        })
        deleteItems = [...verifyItems]
      }

    }
    if(side === 'left') setListaFiltrada([...deleteItems]);
    setItems([...actualItems]);
    setItemsDel([...deleteItems]);
    setSelectedToLeft([])
    setSelectedToRight([])
  }
  const createReportFields = () => {
    let data = [...rightList];

    let report_fields = [];
    for(let entity of data){
      let alias = entity.alias;
      for(let column of entity.columns){
        if(column.target_entity_inter){
          let exist = data.some(item => item.alias === column.name)
          let field = {
            type: 'join',
            field: column.origin_key,
            field_name: `Ref ${column.target_entity_inter}`,
            field_origin: column.main_entity,
            middle_table: column.relation_name,
            relation_type: column.relation_type,
            field_target: column.target_entity_inter,
            field_target_key: column.final_key,
            alias: exist ? column.name : null,
            inversa: column.inversa
          }
          report_fields.push(field)
        }else if(column.relation_name){
          let exist = data.some(item => item.alias === column.name)
          let field = {
            type: 'join',
            field: column.name,
            field_name: '',
            field_origin: column.main_entity,
            middle_table: null,
            relation_type: column.relation_type,
            field_target: column.relation_name,
            field_target_key: column.reference_db ? column.reference_db : column.name,
            alias: exist ? column.name : null,
            inversa: column.inversa,
            origin: column.origin_key
          }
          report_fields.push(field)
        }else{
          let field = {
            type: 'field',
            field: column.name,
            fiel_type: column.data_type,
            field_name: column.name,
            field_origin: column.main_entity,
            middle_table: null,
            relation_type: null,
            field_target: null,
            field_target_key: null,
            alias
          }
          report_fields.push(field)
        }
      }
    }
    let response = {
      initial_entity: data[0].name,
      report_fields,
      whereConditions: [...conditionsFields]
    }
    return response
  }
  const sendToSave = () => {
    let not_exist_null =  conditionsFields.every(subArray => 
      subArray.every(obj => 
          obj.type !== null &&
          obj.origin !== null &&
          obj.field !== null &&
          obj.operator !== null &&
          obj.value !== null &&
          obj.data_type !== null
      )
    );
    if(reportName === null || !not_exist_null){
      enqueueSnackbar( 'Complete los campos requeridos', {
        autoHideDuration: 2000,
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "center",
        },
      });
    }else{
      setAppLoading(true);
      let data_fields = createReportFields();
      let body = {
        repo_nombre: reportName,
        repo_desc: reportDesc,
        repo_fields: JSON.stringify(data_fields)
      }
      crearReporteMutation(body, {
        onSuccess: (data) => {
          setAppLoading(false);
          enqueueSnackbar( data?.mensaje, {
            autoHideDuration: 2000,
            variant: data?.success ? "success" : "error",
            anchorOrigin: {
              vertical: "top",
              horizontal: "center",
            },
          });
          navigate(`/reportes/personalizado`);
        },
        onError: (error) => {
          console.log(error)
        }
      })
    }
  }

  //FILTRO

  const search = (value) => {
    setFiltro(value)
    if(value === ""){
      setListaFiltrada([...leftList])
    }else{
      let data = leftList.map((item, index) => ({ ...item, indexOriginal: index }))
      .filter((item) => item.name.toLowerCase().includes(value.toLowerCase()));
      setListaFiltrada([...data])
    }
  }

  //FUNCTIONS WHERE

  const createFieldsForWhere = () => {
    let data = [...rightList];

    let report_fields = [];
    for(let entity of data){
      let alias = entity.alias;
      for(let column of entity.columns){
        if(!column.target_entity_inter && !column.relation_name){
          let field = {
            type: 'field',
            field: column.name,
            fiel_type: column.data_type,
            field_name: column.name,
            field_origin: column.main_entity,
            middle_table: null,
            relation_type: null,
            field_target: null,
            field_target_key: null,
            alias
          }
          report_fields.push(field)
        }
      }
    }
    return report_fields
  }

  const items_filtro = createFieldsForWhere();

  const add_filtro = (grupo) => {
    let conditions = [...conditionsFields]
    let data = {
      type: "field",
      origin: null,
      field: null,
      operator: null,
      value:null,
      data_type: null,
      alias: null
    }
    conditions[grupo].push(data);
    setConditionsFields(conditions)
  }
  const delete_group = (grupo) => {
    let conditions = [...conditionsFields];
    conditions.splice(grupo, 1);
    setConditionsFields([...conditions])
  }
  const delete_filtro = (grupo, index) => {
    let conditions = [...conditionsFields];
    conditions[grupo].splice(index, 1);
    setConditionsFields([...conditions])
  }
  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
        event.preventDefault();
    }
  };  
  const changeCondition = (grupo, index, value, type) => {
    let conditions = [...conditionsFields];
    switch (type) {
      case 1:
        if(value){
          conditions[grupo][index].origin = value?.field_origin;
          conditions[grupo][index].field = value?.field;
          conditions[grupo][index].data_type = value?.fiel_type;
          conditions[grupo][index].alias = value?.alias;
        }else{
          conditions[grupo][index].origin = null;
          conditions[grupo][index].field = null;
        }
        break;
      case 2:
        conditions[grupo][index].operator = value
        break;
      case 3:
        conditions[grupo][index].value = value
        break;
    
      default:
        break;
    }
    
    setConditionsFields(conditions)
  }
  //SELECT OPERATORS
  const operators = {
    numeric: ["=", "!=", ">", "<", ">=", "<="],
    string: ["=", "!=", "LIKE"],
    boolean: ["=", "!="],
    date: ["=", "!=", ">", "<", ">=", "<="],
  };
  const numericTypes = ["int", "double", "float", "decimal"];
  const stringTypes = ["varchar", "text", "char"];
  const dateTypes = ["date", "datetime", "timestamp"];
  const booleanTypes = ["bool", "boolean", "tinyint(1)"];

  const getOperatorsByType = (field_type) => {

    if (numericTypes.includes(field_type?.toLowerCase())) return operators.numeric;
    if (stringTypes.includes(field_type?.toLowerCase())) return operators.string;
    if (dateTypes.includes(field_type?.toLowerCase())) return operators.date;
    if (booleanTypes.includes(field_type?.toLowerCase())) return operators.boolean;

    // Default a solo igualdad y desigualdad si no reconoce el tipo
    return ["=", "!="];
  };

  return(
    <>
      <Grid container spacing={0} sx={{mt:1}}>
        <Grid item xs={12} sm={12} md={6} lg={2} xl={2} sx={{p:1}} className="center_item">
          <FormControl fullWidth size="small" error={reportName === null}>
            <TextField
            id="report_name"
            label="Nombre reporte"
            name="report_name"
            size="small"
            fullWidth
            value={reportName}
            required
            sx={{
              mt: reportName === null ? 2 : 0
            }}
            onChange={
              (e) => {
                e.target.value === '' ? 
                setReportName(null) : 
                setReportName(e.target.value)
              }
            }
            />
            <FormHelperText>{reportName === null ? 'Ingrese un nombre' : ''}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3} xl={3}  sx={{p:1}} className="center_item">
          <FormControl fullWidth size="small">
            <TextField
              id="report_desc"
              label="Descripción reporte"
              name="report_desc"
              size="small"
              fullWidth
              value={reportDesc}
              onChange={
                (e) => {
                  e.target.value === '' ? 
                  setReportDesc(null) : 
                  setReportDesc(e.target.value)
                }
              }
              />
            <FormHelperText>{''}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={0} sm={0} md={0} lg={5} xl={5} sx={{p:1}} className="center_item">
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={2} xl={2} sx={{p:1}} className="center_item">
          <Button 
            variant="contained" 
            className="btn_system"
            onClick={sendToSave}
            >
              Guardar
          </Button>
        </Grid>
      </Grid>
      <Grid container spacing={2}  sx={{p:2}}>
        <Grid item xs={3} sx={{p:2, flexDirection: 'column'}} className="center_item">
          <TextField
            id="search_entity"
            label="Entidad"
            name="search_entity"
            size="small"
            fullWidth
            value={filtro}
            sx={{mb:2}}
            InputProps={{
              endAdornment: <Search/>
            }}
            onChange={(e) => search(e.target.value)}
            />
          <SideList 
          key='left_list' 
          entities={listaFiltrada} 
          selectedTo={selectedToRight} 
          side='left' 
          handleSelect={handleSelect} 
          rightList={rightList}
          handleSelectAll={handleSelectAllEntity}
          />
        </Grid>
        <Grid item xs={2} sx={{p:1, alignItems: 'center', flexDirection: 'column', gap:2}} className="center_item">
          <Button variant="contained" className="btn_system" onClick={()=>moveItems('left')}> &gt; </Button>
          <Button variant="contained" className="btn_system" onClick={()=>moveItems('right')}> &lt; </Button>
        </Grid>
        <Grid item xs={3} sx={{p:1}} className="center_item">
          <SideList 
          key='right_list' 
          entities={rightList} 
          selectedTo={selectedToLeft} 
          side='right' 
          handleSelect={handleSelect} 
          rightList={rightList} 
          handleSelectAll={handleSelectAllEntity}
          />
        </Grid>
        <Grid item xs={4} sx={{flexDirection:'column', justifyContent:'flex-start'}} className="center_item">
          <Button 
            variant="outlined" 
            className="btn_system"
            fullWidth
            onClick={()=>setConditionsFields([...conditionsFields, []])}
            sx={{mt:2}}
            >
            + Nuevo grupo
          </Button>
          {conditionsFields?.map((group, index_group) => (
            <>
              <div style={{width: '100%', border:'1px solid #575E3B', borderRadius: 12, display:'flex', flexDirection: 'column', padding:5, marginTop:15}}>
                <Grid container spacing={0} sx={{display: 'flex', justifyContent:'space-between'}} >
                  <Grid item xs={4} sx={{p:1}} className="center_item">
                    <Button 
                    variant="contained" 
                    className="btn_system"
                    fullWidth
                    onClick={()=>add_filtro(index_group)}
                    >
                    + Nuevo filtro
                    </Button>
                  </Grid>
                  <Grid item xs={3} sx={{p:1, justifyContent: 'flex-end'}} className="center_item">
                    <IconButton 
                      aria-label="delete"
                      onClick={()=> delete_group(index_group)}
                      >
                      <Cancel />
                    </IconButton>
                  </Grid>
                </Grid>
                {group?.map((cond, index_cond) => (
                  <Grid container spacing={0} >
                    <Grid item xs={5} sx={{p:1}} className="center_item">
                      <FormControl size="small" fullWidth>
                        <Autocomplete
                        fullWidth
                        id={`item_column_${index_cond}_g${index_group}`}
                        getOptionLabel={(opcion) => opcion?.alias ? `${opcion.field}(${opcion.alias})` : opcion.field}
                        filterSelectedOptions
                        options={items_filtro}
                        onKeyDown={handleKeyUp}
                        value={cond !== null ? items_filtro.find(item => item?.field === cond?.field) : null}
                        onChange={(e, newValue)=>changeCondition(index_group, index_cond, newValue, 1)}
                        renderOption={(props, option)=> (
                            <Box {...props} key={`${index_group}_${index_cond}_${option?.field}`}>{`${option?.field} ${option?.alias ? `(${option.alias})` : ''}`}</Box>
                        )}
                        renderInput={(params) => 
                            <TextField {...params} label="Campo" size="small" fullWidth  required/>
                        }
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={2} sx={{p:1}} className="center_item">
                      <Select
                        key={index_cond}
                        labelId={`operator-select-${index_group}-${index_cond}`}
                        id={`operator-select-${index_group}-${index_cond}`}
                        name={`operator-select-${index_group}-${index_cond}`}
                        value={cond?.operator}
                        onChange={(e) => changeCondition(index_group, index_cond, e.target.value, 2)}
                        displayEmpty
                      >
                        {getOperatorsByType(cond?.data_type).map((op) => (
                            <MenuItem key={op} value={op}>{op}</MenuItem>
                        ))}
                      </Select>
                    </Grid>
                    <Grid item xs={4} sx={{p:1}} className="center_item">
                      {
                        booleanTypes.some(item => item === cond?.data_type) ? (
                          <Select
                          key={index_cond}
                          labelId={`item_value_${index_cond}_g${index_group}`}
                          id={`item_value_${index_cond}_g${index_group}`}
                          name={`item_value_${index_cond}_g${index_group}`}
                          value={cond?.value}
                          onChange={(e) => changeCondition(index_group, index_cond, e.target.value, 3)}
                          displayEmpty
                          fullWidth
                        >
                          <MenuItem key={`true-${index_group}-${index_cond}`} value={true}>True</MenuItem>
                          <MenuItem key={`false-${index_group}-${index_cond}`} value={false}>False</MenuItem>
                          </Select>
                        ) : (
                          <TextField
                            id={`item_value_${index_cond}_g${index_group}`}
                            type={
                              dateTypes.some(item => item === cond.data_type) ? "date": 
                              numericTypes.some(item => item === cond.data_type) ? "number" :
                              "text"
                            }
                            fullWidth
                            size="small"
                            value={cond?.value}
                            name={`item_value_${index_cond}_g${index_group}`}
                            hiddenLabel
                            placeholder="Valor referencia"
                            onChange={(e) => changeCondition(index_group, index_cond, e.target.value, 3)}
                            className="input-date"
                          />
                        )
                      }
                      
                    </Grid>
                    <Grid item xs={1} sx={{p:1}} className="center_item">
                      <IconButton 
                      aria-label="delete"
                      onClick={()=> delete_filtro(index_group, index_cond)}
                      >
                        <Delete />
                      </IconButton>
                    </Grid>
                  </Grid>
                ))}
              </div>
            </>
          ))}
        </Grid>
      </Grid>
    </>
  )
}